import React, { useState } from "react";
import { Paper, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { WHITE, IRIS_60 } from "../../colors";
import HeightBox from "../HeightBox";
import ReactTooltip from "react-tooltip";
import MapChart from "./MapChart";

import "./styles.css";

const CustomPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: WHITE,
  paddingTop: 15,
  // height: 250,
  paddingBottom: 10,
  paddingLeft: 15,
  paddingRight: 15,
  boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.05)",
  borderRadius: 10,
  minWidth: 450,
}));
export default function WorldMap(people) {
  const [content, setContent] = useState("");
  return (
    <CustomPaper>
      <Typography fontSize={18} color={IRIS_60} style={{ marginLeft: 25 }}>
        Customers distribution
        <span style={{ color: "black", fontSize: ".8rem", padding: "10px" }}>*no filtering applied</span>
      </Typography>
      <HeightBox height={10} />
      <div>
        <MapChart setTooltipContent={setContent} customers={people.people} />
        <ReactTooltip styles={{ zIndex: 9999 }}>{content}</ReactTooltip>
      </div>
      <p
        style={{
          background: "black",
          color: "white",
          borderRadius: "20px",
          padding: "0 20px",
          // display: "inline",
          margin: 0,
        }}
      >
        {content || "Select a country"}
      </p>
    </CustomPaper>
  );
}
